const envObject = window.environmentObject;

/* eslint-disable */
function passiveSupport() {
	let passiveSupported = false;
	try {
		window.addEventListener(
			'test',
			null,
			Object.defineProperty({}, 'passive', {
				get: function() {
					passiveSupported = true;
				},
			})
		);
	} catch (err) {}

	return passiveSupported;
}
/* eslint-enable */

const env = {
	// Device
	isMobile: envObject.device === 'mobile',
	isDesktop: envObject.device === 'desktop',

	// OS
	isMac: envObject.platform === 'os-x',
	isWin: envObject.platform === 'windows',
	isLinux: envObject.platform === 'linux',
    isChromeOS: envObject.platform === 'chromeos',
	isAndroid: envObject.platform === 'android-os',
	isIOS: envObject.platform === 'i-os',

	// Browsers
    isChrome: envObject.browser === 'chrome',
    isSafari: envObject.browser === 'safari',
    isEdge: envObject.browser === 'edge',
	isFF: envObject.browser === 'firefox',

	// Extra
	havePassive: passiveSupport(),
    reducedMotion: envObject.reducedMotion
};

window.environmentObject = null;
delete window.environmentObject;

export default env;
